import { ColDef } from 'ag-grid-community';
import Member from '../../../ts/models/Member.model';
import { formatTimeLocal } from '../../../utils/time';
import { getStatusName } from '../../../utils/methods';
import {
  DEFAULT_DATE_FILTER_OPS,
  externallyFilteredColDef,
} from '../../../utils/agGrid/options';

const COUNTRY_FIELD = 'country';
const LOCATION_STATE_FIELD = 'locationState';
export const MATCH_FILTER_FIELDS = [COUNTRY_FIELD, LOCATION_STATE_FIELD];
export type MemberGridRow = Member & { id: string };
const columnDefs: ColDef<MemberGridRow>[] = [
  {
    headerName: 'Clearing Member Type',
    field: 'clearingMemberType',
    filter: 'agTextColumnFilter',
    initialWidth: 220,
  },
  {
    headerName: 'Firm Code',
    field: 'firmCode',
    filter: 'agTextColumnFilter',
    initialWidth: 150,
    ...externallyFilteredColDef,
  },
  {
    headerName: 'Name',
    field: 'name',
    filter: 'agTextColumnFilter',
    initialWidth: 150,
    sortable: false,
    ...externallyFilteredColDef,
  },
  {
    headerName: 'E-Market Organization Name',
    field: 'emarketOrganizationName',
    filter: 'agTextColumnFilter',
    initialWidth: 260,
    ...externallyFilteredColDef,
  },
  {
    headerName: 'State',
    field: LOCATION_STATE_FIELD,
    filter: 'agTextColumnFilter',
    initialWidth: 150,
    ...externallyFilteredColDef,
  },
  {
    headerName: 'Country',
    field: COUNTRY_FIELD,
    filter: 'agTextColumnFilter',
    initialWidth: 150,
    ...externallyFilteredColDef,
  },
  {
    headerName: 'Created Date',
    field: 'createdAt',
    valueFormatter: ({ value }) => formatTimeLocal(value),
    filter: 'agDateColumnFilter',
    filterParams: {
      filterOptions: DEFAULT_DATE_FILTER_OPS,
    },
    initialWidth: 150,
  },
  {
    headerName: 'Status',
    field: 'status',
    valueFormatter: ({ value }) => getStatusName(value),
    filter: 'agTextColumnFilter',
    initialWidth: 150,
    ...externallyFilteredColDef,
  },
  {
    field: 'id',
    hide: true,
    filter: 'agTextColumnFilter',
    suppressColumnsToolPanel: true,
    floatingFilter: false,
    initialWidth: 150,
  },
  {
    headerName: 'Status Date',
    field: 'statusDate',
    valueFormatter: ({ value }) => formatTimeLocal(value),
    filter: 'agDateColumnFilter',
    filterParams: {
      filterOptions: DEFAULT_DATE_FILTER_OPS,
    },
    initialWidth: 150,
    sortable: false,
  },
];

export default columnDefs;
